import { useState, useEffect } from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { ErrorBoundary } from 'Features/Error/ErrorBoundary'
import { Header, Footer } from 'Common/Supplyvue-ui'
import brandLogo from 'Assets/images/modelling-brand-logo.png'
import SwitchIcon from 'Assets/icons/switch.svg'
import { getUsername } from 'Features/Auth/auth'
import { AppWrapper, MainContent, brandLogoStyles } from './Layout.styles'

export const Shell = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const tenantName = localStorage.getItem('tenantName') || ''
  const [loadingAuthData, setLoadingAuthData] = useState(true)
  const [userName, setUserName] = useState('')

  useEffect(() => {
    const fetchUserName = async () => {
      const userName = await getUsername()
      setUserName(userName)
      setLoadingAuthData(false)
    }
    fetchUserName()
  }, [])

  useEffect(() => {
    if (!tenantName && location.pathname !== '/tenants')
      window.location.href = `${window.location.origin}/tenants`
    setLoading(false)
  }, [])

  useEffect(() => {
    if (window.location.pathname === '/tenants') {
      localStorage.removeItem('tenantId')
      localStorage.removeItem('tenantsCount')
      localStorage.removeItem('tenantName')
    }
  }, [])

  if (loadingAuthData || loading) {
    return null
  }
  const isTenantSwitchEnabled = (): boolean => {
    const count = localStorage.getItem('tenantsCount') as string
    const tenantsCount = parseInt(count)
    return tenantsCount > 1
  }

  return (
    <AppWrapper>
      <Header
        brandLogo={brandLogo}
        brandLogoStyles={brandLogoStyles}
        profileText={`Welcome ${userName}`}
        tenantName={tenantName}
        switchIcon={<SwitchIcon />}
        handleBrandLogoClick={() => tenantName && navigate('/')}
        handleTenantSwitchClick={() => navigate('/select-tenant')}
        isClickable={isTenantSwitchEnabled()}
      />
      <ErrorBoundary>
        <MainContent>
          <Outlet />
        </MainContent>
      </ErrorBoundary>
      <Footer
        copyrightText="All rights reserved"
        privacyText="Privacy Notice"
        cookiesText="Cookies"
        handlePrivacyClick={() =>
          window.open('https://www.supplyvue.com/privacy-notice/')
        }
        handleCookiesClick={() =>
          window.open('https://www.supplyvue.com/cookies/')
        }
      />
    </AppWrapper>
  )
}
